import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import JoinWithUs from "../../Home/JoinWithUs";
import HeroWeb3Game from "./HeroWeb3Game";
import Web3GameFeatures from "./Web3GameFeatures";
import MarketInsight from "./MarketInsight";
import WhyChooseXeer from "../../DeFi/DeFiStaking/WhyChooseXeer";

function Web3GameDevelopment() {
  return (
    <div className="web3-game-development-page">
      <Header />
      <HeroWeb3Game />
      <MarketInsight />
      <Web3GameFeatures />
      <div style={{ marginTop: "100px" }}>
        <JoinWithUs />
      </div>
      <WhyChooseXeer />
      <Footer />
    </div>
  );
}

export default Web3GameDevelopment;
